import React, { Component } from 'react';
import { DatePicker } from 'antd';
import { inject, observer } from 'mobx-react';

@observer(["CustomWagerStore"])
class StepThree extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectEndTimeMessage: "",
            selectReportingEndTimeMessage: ""
        };
        this.handleEndDateChange = this.handleEndDateChange.bind(this);
        this.handleReportingEndDateChange = this.handleReportingEndDateChange.bind(this);
    }

    componentWillMount() {
        const { CustomWagerStore } = this.props;

        let timeNow = new Date;
        CustomWagerStore.setEndTime(timeNow.getTime() / 1000);
        CustomWagerStore.setReportingEndTime(timeNow.getTime() / 1000);
    }

    handleEndDateChange(moment, dateString) {
        const { CustomWagerStore } = this.props;
        let date = (moment ? moment.toDate() : null);

        console.log(date.getTime() / 1000);

        CustomWagerStore.setEndTime(date.getTime() / 1000);
    }

    handleReportingEndDateChange(moment, dateString) {
        const { CustomWagerStore } = this.props;
        let date = (moment ? moment.toDate() : null);

        console.log(date.getTime() / 1000);

        CustomWagerStore.setReportingEndTime(date.getTime() / 1000);
    }

    render() {

        return (
            <div>
                <h1>Enter End Date and Reporting End Date & Time</h1>
                <div className="custom-bets-form">
                    <div className="custom-bets-form-grid">
                        <div className="custom-bets-form-grid-section-with-background">
                            <div className="custom-bets-form-field">
                                <div className="custom-bets-form-field-title">Bet End time</div>
                                <DatePicker style={{ width: '100% !important' }} showTime onChange={this.handleEndDateChange} />
                                <div className="custom-bets-form-field-error-msg">{this.state.selectEndTimeMessage}</div>
                            </div>
                        </div>
                        <div className="custom-bets-form-grid-section-with-background">
                            <div className="custom-bets-form-field">
                                <div className="custom-bets-form-field-title">Bet Reporting End time</div>
                                <DatePicker style={{ width: '100% !important' }} showTime onChange={this.handleReportingEndDateChange} />
                                <div className="custom-bets-form-field-error-msg">{this.state.selectReportingEndTimeMessage}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default StepThree;


// WEBPACK FOOTER //
// ./src/components/layoutComponents/customBetSteps/StepThree.js